import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalDeactivateProspectDocument = gql`
  mutation SalesPortalDeactivateProspect(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    supplierDeactivateRestaurant(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      success
    }
  }
`;
export type SalesPortalDeactivateProspectMutationFn = Apollo.MutationFunction<
  Types.SalesPortalDeactivateProspectMutation,
  Types.SalesPortalDeactivateProspectMutationVariables
>;
export function useSalesPortalDeactivateProspectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalDeactivateProspectMutation,
    Types.SalesPortalDeactivateProspectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalDeactivateProspectMutation,
    Types.SalesPortalDeactivateProspectMutationVariables
  >(SalesPortalDeactivateProspectDocument, options);
}
export type SalesPortalDeactivateProspectMutationHookResult = ReturnType<
  typeof useSalesPortalDeactivateProspectMutation
>;
export type SalesPortalDeactivateProspectMutationResult =
  Apollo.MutationResult<Types.SalesPortalDeactivateProspectMutation>;
export type SalesPortalDeactivateProspectMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalDeactivateProspectMutation,
    Types.SalesPortalDeactivateProspectMutationVariables
  >;
